export const formatINR = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const { compact = false, decimals = 0 } = opts;
  if (compact) {
    if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)}Cr`;
    if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
    if (n >= 1000) return `₹${(n / 1000).toFixed(1)}k`;
  }
  return `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: decimals, minimumFractionDigits: decimals })}`;
};

export const formatNum = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN");
};

export const formatPct = (n, decimals = 1) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${Number(n).toFixed(decimals)}%`;
};

export const formatDate = (d) => {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const formatShortDate = (d) => {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  } catch {
    return d;
  }
};

// Benchmark health calculations
export const cplHealth = (cpl) => {
  if (!cpl) return "muted";
  if (cpl <= 500) return "success";
  if (cpl <= 900) return "warning";
  return "critical";
};

export const ctrHealth = (ctr) => {
  if (!ctr) return "muted";
  if (ctr >= 6) return "success";
  if (ctr >= 3) return "warning";
  return "critical";
};

export const statusColor = (status) => {
  const map = {
    active: "success",
    paused: "muted",
    limited: "warning",
    learning: "primary",
    ended: "muted",
    removed: "muted",
  };
  return map[status] || "muted";
};
